import React, { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

const faqsAccounting = [
  {
    question: "Who can enroll in this course?",
    answer: "Anyone interested in accounting, taxation, or business management—students, entrepreneurs, job seekers, and professionals looking to upskill—can join this program.",
  },
  {
    question: "Do I need prior accounting knowledge to join?",
    answer: "No prior background is required. The course starts from fundamental concepts and gradually advances to professional accounting techniques.",
  },
  {
    question: "What type of certificate will I receive?",
    answer: "You will receive a Joint Professional Certificate issued by JK Associates & Chartered Skills, officially recognizing your expertise in accounting and compliance.",
  },
  {
    question: "Is the course practical or theoretical?",
    answer: "The course is 80% practical, featuring hands-on exercises with Tally ERP, VAT return submission, and financial statement preparation.",
  },
  {
    question: "How long does it take to complete the full program?",
    answer: "The full course typically runs for 11 sessions, designed for flexible weekly or weekend schedules.",
  },
  {
    question: "What career opportunities can I expect after completion?",
    answer: "Graduates can pursue roles such as Accountant, Tax Consultant, VAT Officer, Audit Assistant, or Business Executive, or manage their own business accounts effectively.",
  },
  {
    question: "Will I receive support after completing the course?",
    answer: "Yes. JK Associates offers lifetime learning and advisory support, helping you apply your skills in real business or job environments.",
  },
  {
    question: "Is there any software training included?",
    answer: "Yes. The program includes Tally ERP training, covering chart of accounts, data entry, report generation, and financial statement automation.",
  },
];

const AccountingFAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqStyle = (isOpen) => ({
    backgroundColor: isOpen ? "#0d6efd" : "#fff",
    color: isOpen ? "#fff" : "#333",
    borderRadius: "12px",
    padding: "15px 20px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
    cursor: "pointer",
    transition: "all 0.3s",
  });

  const answerStyle = {
    marginTop: "10px",
    fontSize: "15px",
    lineHeight: "1.5",
    color: "#fff",
  };

  return (
    <section style={{ padding: "60px 20px", backgroundColor: "#f8f9fa" }}>
      <div
        style={{
          backgroundColor: "#0d6efd",
          color: "white",
          padding: "40px 30px",
          borderTopLeftRadius: "40px",
          borderBottomRightRadius: "10px",
          marginBottom: "40px",
        }}
      >
        <h2 style={{ fontSize: "32px", marginBottom: "15px" }}>Frequently Asked Questions</h2>
        <p style={{ fontSize: "16px", lineHeight: "1.6", margin: 0 }}>
          Here are some common questions and answers about the Professional Accounting Certificate Course.
        </p>
      </div>

      <div style={{ maxWidth: "900px", margin: "0 auto", display: "flex", flexDirection: "column", gap: "15px" }}>
        {faqsAccounting.map((faq, index) => {
          const isOpen = openIndex === index;
          return (
            <div
              key={index}
              style={faqStyle(isOpen)}
              onClick={() => setOpenIndex(isOpen ? null : index)}
            >
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span style={{ fontWeight: "600", fontSize: "16px" }}>{faq.question}</span>
                {isOpen ? <FaChevronUp /> : <FaChevronDown />}
              </div>
              {isOpen && <p style={answerStyle}>{faq.answer}</p>}
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default AccountingFAQSection;
